import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_BEGIN,
  MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_FAILURE,
  MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function fetchValidationCustomerData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getValidationCustomerData?opcoId=${args.opcoId}&customerId=${args.customerId}&isFrom=${args.isFrom}`, null, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(errorMsg);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchValidationCustomerDataError() {
  return {
    type: MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_DISMISS_ERROR,
  };
}

export function useFetchValidationCustomerData() {
  const dispatch = useDispatch();

  const { validationCustomerData, fetchValidationCustomerDataPending, fetchValidationCustomerDataError } = useSelector(
    state => ({
      validationCustomerData: state.manageSubs.validationCustomerData,
      fetchValidationCustomerDataPending: state.manageSubs.fetchValidationCustomerDataPending,
      fetchValidationCustomerDataError: state.manageSubs.fetchValidationCustomerDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchValidationCustomerData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchValidationCustomerDataError());
  }, [dispatch]);

  return {
    validationCustomerData,
    fetchValidationCustomerData: boundAction,
    fetchValidationCustomerDataPending,
    fetchValidationCustomerDataError,
    dismissFetchValidationCustomerDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchValidationCustomerDataPending: true,
        fetchValidationCustomerDataError: null,
      };

    case MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        validationCustomerData: action.data,
        fetchValidationCustomerDataPending: false,
        fetchValidationCustomerDataError: null,
      };

    case MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchValidationCustomerDataPending: false,
        fetchValidationCustomerDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_VALIDATION_CUSTOMER_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchValidationCustomerDataError: null,
      };

    default:
      return state;
  }
}
